<template>
  <div id="app">
    <NavbarComponent/>
    <router-view/>
    <div id=footer-container>
      <div id=footer>
        <b-row>
          <b-col xs=12 lg=4 id='footer-logo'>
            <img v-bind:src="require('./assets/IJS_JSI_logo-02.png')" alt="JSI_logo">
          </b-col>
          <b-col xs=12 lg=8 id='footer-text'>
            <p v-if="$store.getters.language === 'SLO'">The project was supported through Slovenian Research Agency for research core funding for the programmes Knowledge Technologies (No. P2-0103), Computer-assisted multilingual news discourse analysis with contextual embeddings  (No.  J6-2581) and  Hate speech in contemporary conceptualizations of nationalism, racism, gender and migration (No. J5-3102).
            </p>
            <p v-else>The project was supported through Slovenian Research Agency for research core funding for the programmes Knowledge Technologies (No. P2-0103), Computer-assisted multilingual news discourse analysis with contextual embeddings  (No.  J6-2581) and  Hate speech in contemporary conceptualizations of nationalism, racism, gender and migration (No. J5-3102).
            </p>
            <p v-if="$store.getters.language === 'SLO'">Avtorske pravice, July 20, 2022, Inštitut Jožef Stefan - Odsek za tehnologije znanja</p>
            <p v-else>Copyright, July 20, 2022, Jožef Stefan Institute - Department of knowledge technology</p>
          </b-col>
        </b-row>
      </div>
    </div>  
  </div>
</template>

<script>
import NavbarComponent from './components/NavbarComponent.vue';
export default {
  name: 'App',
  components: {
    NavbarComponent
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, function (err) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout')
        }
        throw err;
    });
  },
  mounted() {
    var footerheight = document.getElementById('footer-container').offsetHeight;
    document.getElementById('app').style.paddingBottom = footerheight + 'px';
  }
  
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Castoro&display=swap');
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0px;
  margin: 0px;
  position: relative;
  min-height: 100vh;
}
#title {
  margin-left: 20px;
  margin-top: 170px;
}
.align-center {
  text-align: center;
}
.padding-left {
  padding-left: 20px;
}

.no-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

#footer-container {
  background: #4F6675;
  position: absolute;
  bottom: 0;
  width: 100%;
}

#footer {
  margin-left: 10%;
  margin-right: 10%;
}


#footer-logo {
  padding-top: 55px;


  img {
    opacity: 40%;
    max-width: 120px;
  }
}

#footer-text {
  padding-top: 55px;
  color:  #fff;
  font-size: 14px;
  font-weight: 300
}

</style>